import { loadBeacons, loadPreviewBeacons } from '../utils/loadBeacons';
import {
  setGAClientIDCustomDimension,
  setGAAdBlockTrackingCustomDimension,
  setChartbeatGAIntegration
} from '../utils/analytics';

export default store => {
  const {
    isPreviewPage
  } = store.getState();

  if (isPreviewPage) {
    return loadPreviewBeacons(store);
  }
  loadBeacons(store);
  setGAClientIDCustomDimension();
  setGAAdBlockTrackingCustomDimension();
  setChartbeatGAIntegration();
};
